import {
  ISolCustomerCurrency,
  ISolCustomerDenomination,
} from "@/entities/sol_customer/currency/currency.types";

export class SolCustomerDenomination implements ISolCustomerDenomination {
  code?: string;
  commodityTypeCode?: string;
  commodityTypeDescription?: string;
  description?: string;
  id: string;
  value?: number;

  constructor(data: ISolCustomerDenomination) {
    this.code = data.code;
    this.commodityTypeCode = data.commodityTypeCode;
    this.commodityTypeDescription = data.commodityTypeDescription;
    this.description = data.description;
    this.id = data.id;
    this.value = data.value;
  }
}

export class SolCustomerCurrency implements ISolCustomerCurrency {
  currencyId?: string;
  denominations?: SolCustomerDenomination[];
  description?: string;
  isoCode?: string;
  mainCurrency?: boolean;
  symbol?: string;

  constructor(data: ISolCustomerCurrency) {
    this.currencyId = data.currencyId;
    this.denominations = data.denominations;
    this.description = data.description;
    this.isoCode = data.isoCode;
    this.mainCurrency = data.mainCurrency;
    this.symbol = data.symbol;

    this.denominations = data.denominations?.map(
      (denomination) => new SolCustomerDenomination(denomination)
    );
  }
}
